import { ServiceStateEnum } from '@mwe/constants';

export abstract class ServiceStateEnumExporter {
  public get serviceStateEnum(): typeof ServiceStateEnum {
    return ServiceStateEnum;
  }
}
